import { Box } from '@hub/box';
import { IconButton } from '@hub/button';
import { SearchMediumIcon } from '@hub/icon';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchButton = ({
  onClick,
  controlledElementId,
  sx
}) => /*#__PURE__*/_jsx(Box, {
  role: "search",
  sx: sx,
  children: /*#__PURE__*/_jsx(IconButton, {
    icon: /*#__PURE__*/_jsx(SearchMediumIcon, {
      boxSize: "size-icon-md"
    }),
    "aria-label": "Open Search, you can search stores, brands, products, and more",
    variant: "transparent",
    colorScheme: "licorice",
    "aria-controls": controlledElementId,
    sx: {
      minWidth: 0,
      height: 'auto'
    },
    onClick: onClick
  })
});